import { InputAdornment } from '@mui/material'
import { C1CopyText } from 'components/core/copytext/C1CopyText'
import { useEffect, useState } from 'react'

export const getTenantIDFromLocation = (location: Location): string => location.hostname.split('.')[0]
export const getInstallationDomain = (location: Location): string => {
    // get everything after the tenant id
    const parts = location.hostname.split('.')
    parts.shift() // remove the first part (tenant ID)
    const domain = parts.join('.')
    return domain
}

export const InstallationDomain = (): React.ReactElement => {
    const [installationDomain, setInstallationDomain] = useState('')

    useEffect(() => {
        setInstallationDomain(getInstallationDomain(window.location))
    }, [])
    return <span>{installationDomain}</span>
}

export const TenantDomain = (): React.ReactElement => {
    const [tenantDomain, setTenantDomain] = useState('')

    useEffect(() => {
        setTenantDomain(getTenantIDFromLocation(window.location))
    }, [])

    return <span>{tenantDomain}</span>
}

type InstallationURLProps = {
    path?: string
    subdomain?: string
}

const constructInstallationURL = (location: Location, subdomain?: string, path?: string): string => {
    const installationDomain = getInstallationDomain(location)
    const u = new URL('https://conductor.one/')
    u.hostname = `${subdomain ? `${subdomain}.` : ''}${installationDomain}`
    u.pathname = path ? `${path}` : ''
    u.protocol = 'https:'
    return u.toString()
}

export const InstallationURL = ({ path, subdomain }: InstallationURLProps): string => {
    const [url, setUrl] = useState<string>('')
    useEffect(() => {
        setUrl(constructInstallationURL(window.location, subdomain, path))
    }, [path, subdomain, setUrl])
    return url
}

type InstallationLinkProps = InstallationURLProps & {
    children: React.ReactNode
}

export const InstallationLink = ({ path, subdomain, children }: InstallationLinkProps): React.ReactElement => {
    const [url, setUrl] = useState<string>('')
    useEffect(() => {
        setUrl(constructInstallationURL(window.location, subdomain, path))
    }, [path, subdomain, setUrl])
    return <a href={url}>{children}</a>
}

export const AccountsCallbackLink = (): React.ReactElement => {
    return <InstallationLink path="/auth/callback" subdomain="accounts">
        <InstallationURL path="/auth/callback" subdomain="accounts" />
    </InstallationLink>
}

export const AccountsCallbackCopyable = (): React.ReactElement => {
    const [url, setUrl] = useState<string>('')
    useEffect(() => {
        setUrl(constructInstallationURL(window.location, 'accounts', '/auth/callback'))
    }, [setUrl])
    return <C1CopyText typographyVariant="monospace" value={url} />
}

export const InstallationURLCopyable = ({ path, subdomain }: InstallationURLProps): React.ReactElement => {
    const [url, setUrl] = useState<string>('')
    useEffect(() => {
        setUrl(constructInstallationURL(window.location, subdomain, path))
    }, [setUrl, subdomain, path])
    return <C1CopyText typographyVariant="monospace" value={url} />
}

export const InstallationDomainInputAdornment = (): React.ReactElement => {
    return <InputAdornment position="end">
        .
        <InstallationDomain />
    </InputAdornment>
}
